import { titleCase } from "./string"

export const formatPhoneNumber = (number) => {
  const match = number.match(/^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?)(\d[- ]?\d{3})$/)
  if (match && match.length === 5) { return `(${match[2].trim()}) ${match[3].trim()} ${match[4].trim()}` }
  return number
}

export const formatAddress = ({
  address1,
  address2,
  address3,
  postcode,
  state,
  townName
}) =>
  `${[
    address1,
    address2,
    address3
  ].filter(Boolean).join(" ")
  }, ${
    titleCase(townName)
  } ${state} ${postcode}`



// WEBPACK FOOTER //
// ./src/utils/formatters.js